<template>
    <div>
        <b-alert show v-if="dist === null" variant="warning"> {{ $t("appIsNotBuilt") }} </b-alert>

        <template v-else>
            <PowerAppV3 :app="app" :entrypoint="entrypoint" :dist="dist" :noRouter="noRouter" v-on="$listeners" v-bind="$attrs" v-if="app.app_version == 3"/>
            <PowerAppV4 :app="app" :entrypoint="entrypoint" :dist="dist" :noRouter="noRouter" v-on="$listeners" v-bind="$attrs" v-if="app.app_version == 4"/>
            <PowerAppV5 :app="app" :entrypoint="entrypoint" :dist="dist" :noRouter="noRouter" v-on="$listeners" v-bind="$attrs" v-if="app.app_version == 5"/>
        </template>
    </div>
</template>

<script>
import PowerAppV3 from './PowerAppV3';
import PowerAppV4 from './PowerAppV4';
import PowerAppV5 from './PowerAppV5';

export default {
    name: 'PowerApp',
    components: {
        PowerAppV3,
        PowerAppV4,
        PowerAppV5
    },
    props: {
        app: {
            type: Object
        },

        dist: {
            type: Object
        },
        
        entrypoint: {
            type: String,
            default: "index"
        },
        
        noRouter: {
            type: Boolean,
            default: false
        }
    }
}
</script>